import React, { useState } from 'react';

const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-blue-100 to-ocean-100">
      <div className="section">
        <h1 className="section-header">Contact Us</h1>
        
        <div className="maritime-card p-8 mb-16 text-center">
          <h2 className="text-2xl font-bold text-ocean-800 mb-4">Get In Touch</h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            We're here to help with all your offshore marine service needs. Contact us today 
            to discuss your requirements and discover how PetroMarine can support your operations.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="maritime-card p-8">
              <h2 className="text-2xl font-bold text-ocean-800 mb-6">Our Offices</h2>
              
              {/* Egypt Office */}
              <div className="mb-8 pb-8 border-b border-gray-200">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 bg-ocean-100 rounded-full flex items-center justify-center mr-3">
                    <svg className="w-4 h-4 text-ocean-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-ocean-800">Egypt Office</h3>
                </div>
                <div className="space-y-3 text-gray-700">
                  <p className="flex items-start">
                    <svg className="w-5 h-5 text-ocean-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                    West Alyat St., Souby Boghdady Towers, Building C<br />
                    Suite 1203 Gemaiza<br />
                    Alexandria - Egypt
                  </p>
                  <p className="flex items-center">
                    <svg className="w-5 h-5 text-ocean-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                    </svg>
                    Tel: +20 3 420 22 272 Ext.6569
                  </p>
                  <p className="flex items-center">
                    <svg className="w-5 h-5 text-ocean-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                    </svg>
                    Fax: +20 3 420 96 246
                  </p>
                  <p className="flex items-center">
                    <svg className="w-5 h-5 text-ocean-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                    </svg>
                    Email: operation@petro-marine.net
                  </p>
                </div>
              </div>

              {/* UAE Office */}
              <div>
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 bg-ocean-100 rounded-full flex items-center justify-center mr-3">
                    <svg className="w-4 h-4 text-ocean-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-ocean-800">UAE Office</h3>
                </div>
                <div className="space-y-3 text-gray-700">
                  <p className="flex items-start">
                    <svg className="w-5 h-5 text-ocean-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                    M-36, Plot No. 18, Office 25, Mussafah<br />
                    Abu Dhabi, UAE
                  </p>
                  <p className="flex items-center">
                    <svg className="w-5 h-5 text-ocean-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                    </svg>
                    Tel: +971 50 562 3700
                  </p>
                  <p className="flex items-center">
                    <svg className="w-5 h-5 text-ocean-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                    </svg>
                    Email: operation@petro-marine.net
                  </p>
                </div>
              </div>
            </div>

            <div className="maritime-card p-8">
              <h2 className="text-2xl font-bold text-ocean-800 mb-6">Business Hours</h2>
              <div className="space-y-3 text-gray-700">
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium">Monday - Thursday</span>
                  <span>8:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium">Friday</span>
                  <span>8:00 AM - 12:00 PM</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium">Saturday</span>
                  <span>9:00 AM - 2:00 PM</span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="font-medium">Emergency Response</span>
                  <span className="text-red-600 font-semibold">24/7</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="maritime-card p-8">
            <h2 className="text-2xl font-bold text-ocean-800 mb-6">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Company
                  </label>
                  <input
                    type="text"
                    value={formData.company}
                    onChange={(e) => handleInputChange('company', e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subject <span className="text-red-500">*</span>
                </label>
                <select
                  required
                  value={formData.subject}
                  onChange={(e) => handleInputChange('subject', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                >
                  <option value="">Select a subject</option>
                  <option value="vessel-charter">Vessel Charter Inquiry</option>
                  <option value="crew-services">Crew Services</option>
                  <option value="project-support">Project Support</option>
                  <option value="emergency-response">Emergency Response</option>
                  <option value="general-inquiry">General Inquiry</option>
                  <option value="career-opportunities">Career Opportunities</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  required
                  rows={6}
                  value={formData.message}
                  onChange={(e) => handleInputChange('message', e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-ocean-500 focus:border-transparent"
                  placeholder="Please provide details about your inquiry..."
                />
              </div>

              <button
                type="submit"
                className="w-full btn-primary py-4 text-lg"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Quick Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="maritime-card p-6 text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"/>
              </svg>
            </div>
            <h3 className="font-semibold text-ocean-800 mb-2">Emergency Response</h3>
            <p className="text-gray-600 text-sm mb-4">24/7 emergency support services</p>
            <button className="text-red-600 font-semibold hover:text-red-700">
              Call Emergency Line
            </button>
          </div>

          <div className="maritime-card p-6 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
              </svg>
            </div>
            <h3 className="font-semibold text-ocean-800 mb-2">Email Support</h3>
            <p className="text-gray-600 text-sm mb-4">Get detailed information via email</p>
            <a href="mailto:operation@petro-marine.net" className="text-ocean-600 font-semibold hover:text-ocean-700">
              operation@petro-marine.net
            </a>
          </div>

          <div className="maritime-card p-6 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
              </svg>
            </div>
            <h3 className="font-semibold text-ocean-800 mb-2">Phone Support</h3>
            <p className="text-gray-600 text-sm mb-4">Speak directly with our team</p>
            <div className="space-y-1">
              <p className="text-ocean-600 font-semibold text-sm">Egypt: +20 3 420 22 272</p>
              <p className="text-ocean-600 font-semibold text-sm">UAE: +971 50 562 3700</p>
            </div>
          </div>
        </div>

        <div className="maritime-card p-8 text-center">
          <h2 className="text-2xl font-bold text-ocean-800 mb-4">Quality Services to the Offshore Industry in the Middle East</h2>
          <p className="text-gray-600 italic">
            © 2025 PetroMarine Offshore Projects Support Co. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;